'use client';

/**
 * Utilities for Progressive Web App functionality
 */

/**
 * Detects if the app is running in standalone mode (installed as PWA)
 * @returns {boolean} True if the app is running in standalone mode
 */
export function isPWA(): boolean {
  if (typeof window === 'undefined') {
    console.log('isPWA: window is undefined, returning false');
    return false;
  }
  
  const standalone = window.matchMedia('(display-mode: standalone)').matches;
  const fullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
  const navigatorStandalone = (window.navigator as any).standalone === true;
  
  console.log('isPWA: standalone:', standalone, 'fullscreen:', fullscreen, 'navigatorStandalone:', navigatorStandalone);
  
  const result = standalone || fullscreen || navigatorStandalone;
  console.log('isPWA: final result:', result);
  
  return result;
}

/**
 * Detects if the app is running on iOS
 * @returns {boolean} True if the app is running on iOS
 */
export function isIOS(): boolean {
  if (typeof window === 'undefined') return false;
  
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
}

/**
 * Detects if the app can be installed (has service worker and not already installed)
 * @returns {boolean} True if the app can be installed
 */
export function canInstallPWA(): boolean {
  return 'serviceWorker' in navigator && !isPWA();
}
